import {
  Autocomplete,
  Box,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Grid,
  TextField,
} from "@mui/material";
import Label from "../../../components/Label/Label";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  getCountsPerDrugProducts,
  getDrugProducts,
} from "../../../redux/investigation/actions";

const ProductCard = () => {
  const dispatch = useDispatch();
  const drugProducts = useSelector(
    (state) => state?.investigation?.drugProducts
  );
  const countsPerDrugProducts = useSelector(
    (state) => state?.investigation?.countsPerDrugProducts
  );

  const [drugType, setDrugType] = useState("");
  const [statusLoading, setStatusLoading] = useState(false);

  useEffect(() => {
    dispatch(getDrugProducts());
    dispatch(getCountsPerDrugProducts());
  }, []);

  useEffect(() => {
    setStatusLoading(false);
  }, [countsPerDrugProducts]);

  const onChangeProductMenu = (product) => {
    dispatch(getCountsPerDrugProducts(product?.name));
    setDrugType(product?.name);
    setStatusLoading(true);
  };

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      <Card variant="outlined" className="weidget-count-drug-products">
        <CardContent style={{ padding: "10px" }}>
          {statusLoading && (
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1,
              }}
            >
              <CircularProgress />
            </Box>
          )}
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            width="100%"
            justifyContent="space-between"
          >
            <Label text="Product" fontSize="16px" fontWeight="600" />

            <Box
              variant="outlined"
              className="weidget-count-card-box-drug-products"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: "#F5F5F5",
                padding: "10px",
              }}
            >
              <Box style={{ marginRight: "10px" }}>
                <Label text="Total Products" fontSize="12px" fontWeight="500" />
              </Box>
              <Box>
                <Label
                  text={countsPerDrugProducts?.total_products_count}
                  fontSize="12px"
                  fontWeight="700"
                />
              </Box>
            </Box>
          </Box>
          <FormControl variant="standard">
            <Autocomplete
              size="small"
              options={drugProducts || []}
              getOptionLabel={(option) => option?.name || ""}
              value={drugProducts?.find((p) => p.name === drugType) || null}
              onChange={(event, newValue) => onChangeProductMenu(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Product" variant="standard" />
              )}
              isOptionEqualToValue={(option, value) =>
                option?.name === value?.name
              }
              sx={{
                width: 200,
                paddingBottom: "5px",
              }}
            />
          </FormControl>
          <Grid container spacing={1} xs={12}>
            <Grid item xs={2} sm={6} md={6}>
              <Box
                variant="outlined"
                className="weidget-count-card-box-drug-products"
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: "#F5F5F5",
                    height: "100%",
                  }}
                >
                  <Box style={{ width: "70%" }}>
                    <Label
                      text="Total Templates"
                      fontSize="14px"
                      fontWeight="500"
                      paddingLeft="10px"
                    />
                  </Box>
                  <Box style={{ width: "30%" }}>
                    <Label
                      text={countsPerDrugProducts?.total_templates_count}
                      fontSize="14px"
                      fontWeight="700"
                      textAlign="center"
                    />
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={2} sm={6} md={6} style={{ paddingBottom: "10px" }}>
              <Box
                variant="outlined"
                className="weidget-count-card-box-drug-products"
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: "#F5F5F5",
                    height: "100%",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <Label
                      text="Total PDFs"
                      fontSize="14px"
                      fontWeight="500"
                      paddingLeft="10px"
                    />
                  </div>
                  <div style={{ width: "30%" }}>
                    <Label
                      text={countsPerDrugProducts?.total_pdfs_count}
                      fontSize="14px"
                      fontWeight="700"
                      textAlign="center"
                    />
                  </div>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={2} sm={6} md={6}>
              <Box
                variant="outlined"
                className="weidget-count-card-box-drug-products"
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: "#F5F5F5",
                    height: "100%",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <Label
                      text="Total Batches"
                      fontSize="14px"
                      fontWeight="500"
                      paddingLeft="10px"
                    />
                  </div>
                  <div style={{ width: "30%" }}>
                    <Label
                      text={countsPerDrugProducts?.total_batches_count}
                      fontSize="14px"
                      fontWeight="700"
                      textAlign="center"
                    />
                  </div>
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={2}
              sm={6}
              md={6}
              // style={{ paddingBottom: "10px" }}
            >
              <Box
                variant="outlined"
                className="weidget-count-card-box-drug-products"
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: "#F5F5F5",
                    height: "100%",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <Label
                      text="Batches Completed"
                      fontSize="14px"
                      fontWeight="500"
                      paddingLeft="10px"
                    />
                  </div>
                  <div style={{ width: "30%" }}>
                    <Label
                      text={countsPerDrugProducts?.completed_batches_count}
                      fontSize="14px"
                      fontWeight="700"
                      textAlign="center"
                    />
                  </div>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProductCard;
